import { render, staticRenderFns } from "./SubscribePromoHero.vue?vue&type=template&id=4bad051a&scoped=true&"
import script from "./SubscribePromoHero.vue?vue&type=script&lang=js&"
export * from "./SubscribePromoHero.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePromoHero.vue?vue&type=style&index=0&id=4bad051a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad051a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribeStats: require('/opt/render/project/src/channels2022/src/components/subscribe/SubscribeStats.vue').default,SubscribePromoButton: require('/opt/render/project/src/channels2022/src/components/subscribe-promo/SubscribePromoButton.vue').default,SubscribeHeroBanner: require('/opt/render/project/src/channels2022/src/components/subscribe/SubscribeHeroBanner.vue').default})
